export function getPlaceIdFromUrl() {
  if (window.location.href.includes("/map#")) {
    const hash = window.location.hash;
    if (hash && hash.startsWith("#")) {
      const placeId = hash.substring(1);
      return placeId;
    }
  }
  return null;
}
